/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для кнопки, управляющей скрытием/показом текстовых блоков.
   */
  app.ToggleTextBlocksView = app.View.extend({
    el: '.toggle',
    
    events: {
      'click': 'toggleTextBlocks'
    },
    
    run: function () {
      this.textBlock = this.$el.siblings('.toggle-content');
    },
    
    toggleTextBlocks: function () {
      this.textBlock.toggle(400);
    }
  });
})();

}.call(window));